/* eslint-disable indent */
import React from "react";
import PropTypes from "prop-types";
// import ReactTooltip from "react-tooltip";

import SelectInput2 from "../../../component/input/SelectInput2";
import TextInput2 from "../../../component/input/TextInput2";
import { renderLocationFunction } from "../../../constant/helper/helper";

import SpinnerButton from "../../../component/spinner/SpinnerButton";
import Button from "../../../component/button/Button";

const TopInput = ({
  values,
  loading,
  onSubmit,
  onChange,
  allLocations,
  currentUser
}) => {
  return (
    <div className="row">
      <div className="col-3">
        <TextInput2
          data-tip
          type="date"
          name="date"
          onChange={onChange}
          value={values.date}
          data-for="date"
          icon="mdi mdi-calendar-check"
          placeholder="Select Date"
        />
      </div>
      <div className="col-3">
        {currentUser.workerDepartment === "SUPER ADMIN" &&
        currentUser.workerDesignation === "SUPER ADMIN" ? (
          <SelectInput2
            data-tip
            name="locationId"
            isLabeled={true}
            onChange={onChange}
            icon="mdi mdi-map-marker-radius"
            data-for="locationId"
            label="Select Location"
            value={values.locationId}
            placeholder="Select Location"
          >
            {renderLocationFunction(allLocations)}
          </SelectInput2>
        ) : (
          <TextInput2
            data-tip
            type="text"
            name="text"
            readonly={true}
            value={localStorage.locationName}
            data-for="locationId"
            icon="mdi mdi-map-marker-radius"
            placeholder="Location"
          />
        )}
      </div>
      {loading === true ? (
        <div className="col-sm-2">
          <SpinnerButton />
        </div>
      ) : (
        <div className="col-2">
          <div className="form-group">
            <Button
              type="button"
              onClick={onSubmit}
              title="GET"
              isBackgroundColor={false}
              icon="mdi mdi-plus-circle-outline mr-2"
              className="btn mb-2 text-white btn-dark btn-block"
            />
          </div>
        </div>
      )}
    </div>
  );
};

TopInput.propTypes = {
  loading: PropTypes.bool.isRequired,
  values: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  allLocations: PropTypes.array.isRequired,
  currentUser: PropTypes.object.isRequired
};

export default TopInput;
